<mat-toolbar color="accent" (contextmenu)="onContextMenu($event, null)">
    <mat-toolbar-row>
        <span>{{mediaTree.name}}</span>
        <span class="default-spacer"></span>
        <button mat-icon-button (click)="createFolder(null, mediaTree)"
            matTooltip="{{ 'folder-tree.tooltip.new-folder' | translate }}">
            <mat-icon aria-hidden="false" aria-label="Nuova Cartella">create_new_folder</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding (click)="folderClick(node)"
        (contextmenu)="onContextMenu($event, node)"
        [ngClass]="[selectedFolder && selectedFolder.mediaFolderId == node.mediaFolderId ? 'selected-folder': '']">
        <button mat-icon-button disabled></button>
        <mat-icon class=" tree-folder-icon"
            [color]="!selectedFolder || selectedFolder.mediaFolderId != node.mediaFolderId ? 'primary' : ''">folder
        </mat-icon>
        <div class="tree-folder-name">{{ node.getName(utils.getLanguage()) }}</div>
        <button mat-icon-button [matMenuTriggerFor]="folderMenu" [matMenuTriggerData]="{node: node}"
            (click)="$event.stopPropagation()" matTooltip="{{ 'folder-tree.tooltip.open-menu' | translate }}">
            <mat-icon class="tree-folder-icon">
                create
            </mat-icon>
        </button>
    </mat-tree-node>
    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding (click)="folderClick(node)"
        (contextmenu)="onContextMenu($event, node)"
        [ngClass]="[selectedFolder && selectedFolder.mediaFolderId == node.mediaFolderId ? 'selected-folder': '']">
        <button mat-icon-button [attr.aria-label]="'toggle ' + node.filename" matTreeNodeToggle>
            <mat-icon class="tree-folder-icon">
                {{treeControl.isExpanded(node) ? 'remove' : 'add'}}
            </mat-icon>
        </button>
        <!--mat-spinner [color]="!selectedFolder || selectedFolder.mediaFolderId != node.mediaFolderId ? 'primary' : ''"
            class="tree-folder-icon" *ngIf="node.isLoading" [diameter]="24"></mat-spinner -->
        <mat-icon class="tree-folder-icon"
            [color]="!selectedFolder || selectedFolder.mediaFolderId != node.mediaFolderId ? 'primary' : ''">folder
        </mat-icon> <!-- *ngIf="!node.isLoading" -->
        <div class="tree-folder-name">{{ node.getName(utils.getLanguage()) }}</div>
        <button mat-icon-button [matMenuTriggerFor]="folderMenu" [matMenuTriggerData]="{node: node}"
            (click)="$event.stopPropagation()" matTooltip="{{ 'folder-tree.tooltip.open-menu' | translate }}">
            <mat-icon class="tree-folder-icon">
                create
            </mat-icon>
        </button>
    </mat-tree-node>
</mat-tree>

<div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x"
    [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="folderMenu" #folderMenuTrigger>
</div>

<div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x"
    [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="treeMenu" #treeMenuTrigger>
</div>

<mat-menu #folderMenu="matMenu">
    <ng-template let-node="node" matMenuContent>
        <button mat-menu-item (click)="createFolder(node, mediaTree)">
            <mat-icon class="tree-folder-icon">
                create_new_folder
            </mat-icon>
            {{ 'folder-tree.button.new-folder' | translate }}
        </button>
        <button mat-menu-item (click)="renameFolder(node)">
            <mat-icon class="tree-folder-icon">
                create
            </mat-icon>
            {{ 'folder-tree.button.rename' | translate }}
        </button>
        <button mat-menu-item (click)="moveFolder(node, mediaTree)">
            <mat-icon class="tree-folder-icon">
                open_with
            </mat-icon>
            {{ 'folder-tree.button.move' | translate }}
        </button>
        <button mat-menu-item (click)="deleteFolder(node)">
            <mat-icon class="tree-folder-icon">
                delete
            </mat-icon>
            {{ 'folder-tree.button.delete' | translate }}
        </button>
    </ng-template>
</mat-menu>
<mat-menu #treeMenu="matMenu">
    <ng-template matMenuContent>
        <button mat-menu-item (click)="createFolder(null, mediaTree)">
            <mat-icon class="tree-folder-icon">
                create_new_folder
            </mat-icon>
            {{ 'folder-tree.button.new-folder' | translate }}
        </button>
    </ng-template>
</mat-menu>